<template>
  <div class="video-item" @click="goDetail">
    <div class="img" :style="{backgroundImage: `url(${info.img})`}">
      <!-- <img :src="info.img" /> -->
      <img class="play" src="../../assets/img/play.png" alt="" />
    </div>
    <div class="content">
      <div class="title">
        {{info.title}}
      </div>
      <div class="sub-title">
        <span class="name">{{info.speaker}}</span>
        <span class="office">{{info.office}}</span>
      </div>
      <div class="desc">
        {{info.desc}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    goDetail () {
      if (this.info.link) {
        window.open(this.info.link, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video-item {
  width: 534px;
  border-radius: 5px;
  box-shadow: 0px 2px 23px 2px rgba(0, 0, 0, 0.04);
  cursor: pointer;

  &:hover {
    box-shadow: 0px 2px 23px 2px rgba(0, 0, 0, 0.06);
    & .content .title{
      color: $blue;
    }
  }

  & .img {
    position: relative;
    height: 225px;
    padding-bottom: 4px;
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
    border-radius: 5px 5px 0 0;
    overflow: hidden;

    & .play {
      position: absolute; top: 50%; left: 50%; z-index: 2;
      width: 49px; height: 49px;
      transform: translate(-50%, -50%);

      @include isMobile {
        width: 39px; height: 39px;
      }
    }

    @include isMobile {
      height: 132px;
    }

    &::before {
      content: '';
      position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 2;
      background: $black;
      opacity: .4;
    }

    &::after {
      content: '';
      position: absolute; bottom: 0; left: 0; z-index: 3;
      height: 4px; width: 100%;
      background-image: linear-gradient(to right, $blue, $green);

      @include isMobile {
        height: 2px;
      }
    }
  }

  & .content {
    padding: 18px 29px;

    @include isMobile {
      padding: 10px 16px;
    }

    & .title {
      margin-bottom: 9px;
      color: $black;
      line-height: 24px;
      @include font(18, 500);

      @include isMobile {
        margin-bottom: 3px;
        line-height: 18px;
        @include font(14, 500);
      }
    }

    & .sub-title {
      display: flex; align-items: center;
      margin-bottom: 11px;

      @include isMobile {
        margin-bottom: 4px;
      }
      & .name {
        margin-right: 10px;
        color: $blue;
        @include lineFont(16, 500);
        @include isMobile {
          line-height: 21px;
          @include font(12, 500);
        }
      }
      & .office {
        color: $black;
        @include lineFont(14, 400);
        @include isMobile {
          line-height: 12px;
          @include font(11, 400);
        }
      }
    }

    & .desc {
      color: $lightGray;
      line-height: 20px;
      @include font(14, 400);
      @include row(4);
      @include isMobile {
        line-height: 16px;
        @include font(12, 400);
      }
    }
  }
}
</style>